// Email from an archived customer, waiting in Org Settings → Held Emails for an admin to restore the customer and
// create the ticket, or discard it. Deleted automatically at deleteAt.
export interface HeldEmailResponse {
  id: string;
  organizationId: string;
  organizationName: string;
  fromEmail: string;
  fromName: string;
  customerId?: string | null;
  customerName?: string | null;
  subject: string;
  preview: string;
  attachmentCount: number;
  receivedAt: string;
  deleteAt: string;
}

// Inbound email statuses a release can end in (server InboundEmailStatus)
export const InboundEmailStatus = {
  Processed: 3,
  Failed: 4,
} as const;

// What releasing a held email did: Processed with the ticket it went into, or Failed (retried automatically)
export interface HeldEmailReleaseResponse {
  status: number;
  actionTaken?: number | null;
  ticketId?: string | null;
  ticketNumber?: number | null;
  error?: string | null;
}
